import { FormText } from './FormText'

export function FormTextPrintEditor (props) {
  return <FormText {...props} />
}
